var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crpg-a-private-cruising-photo-gallery"},[_c('img',{attrs:{"src":require(("@/assets/img/privateCruising/" + (this.path)))},on:{"click":_vm.zoomEvent}})])}
var staticRenderFns = []

export { render, staticRenderFns }